<template>
  <div class="form">
    <div
      v-for="field in fields"
      :key="field.name"
      class="inputRow"
    >
      <div v-if="field.type === 'string'">
        <label class="inputLabel">{{ field.label || field.name }}</label>
        <input
          v-model="user[field.name]"
          class="input"
        >
      </div>
      <div
        v-if="field.type === 'lineBreak'"
        class="lineBreak"
      />
    </div>
    <div class="actionRow">
      <button
        class="action"
        @click="save"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  name: 'ProfileForm',
  props: {
    fields: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      user: {},
    };
  },
  async mounted() {
    if (store.state.user) {
      const currentUser = await this.$Amplify.Auth.currentUserInfo();
      this.user = {
        username: currentUser.username,
        ...currentUser.attributes,
      };
    }
  },
  methods: {
    save() {
      const cognitoUser = store.state.user;
      if (!this.user || !cognitoUser) { return; }
      this.$Amplify.Auth
        .updateUserAttributes(cognitoUser, this.user)
        .then((res) => {
          console.info('$Amplify.Auth updateUserAttributes', res);
        })
        .catch(e => console.error(e));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/ProfileForm.vue